
import { defineComponent, getCurrentInstance } from 'vue';

export default defineComponent({
  props: {
    type: {
      type: String,
      default: 'text',
    },

    modelValue: {
      type: String,
    },

    label: {
      type: String,
    },

    errors: {
      type: Array,
    },

    placeholder: {
      type: String,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
  },

  data(): {
    value?: string;
  } {
    return {
      value: undefined,
    };
  },

  computed: {
    name(): string {
      return 'input-' + getCurrentInstance()?.uid;
    },
  },

  watch: {
    modelValue(): void {
      this.value = this.modelValue;
    },

    value(): void {
      this.$emit('update:modelValue', this.value == '' ? undefined : this.value);
    },
  },

  mounted() {
    this.value = this.modelValue;
  },

  methods: {
    focus() {
      (this.$refs.input as HTMLInputElement).focus();
    },
  },
});
